
import * as apis from '@/api';
import Avatar from '@/components/avatar';
import { GetItemDuration , GetItemName, GetItemSkinName } from '@/tool';
import { mapState } from "vuex"

export default {

	components: {
		'c-avatar': Avatar,
	},

	filters: {
		GetItemDuration,
		GetItemName,
		GetItemSkinName
	},
	data() {
		return {
			/** 开箱历史记录 */
			best_drop:[],
			cases_opened: [],
			cases_best_opened: [],
			stock_cases_opened: [],
			stock_cases_best_opened: [],
			timer: null,
			pause_flag:false,
			drop_type: 0,
			best_item:null
		};
	},
	props: {
		/** 箱子编号 */
		caseId: {
			type: Number,
			default: 0
		},
	},
	computed: {
		...mapState([
			'pageHidden',
		]),
		livefeed_items(){
			return this.cases_opened.filter(this.isGameTypeVisible).slice(0,11);
		},	
		livefeed_top_items(){
			return this.cases_best_opened.filter(this.isGameTypeVisible).slice(0,10);
		},			
		//为了满足vue transition-group 的更新机制
		livefeed_index(){
			return function(index){
				var newindex= this.cases_opened.length - index;
				return newindex;
			}
		},
		livefeed_top_index(){
			return function(index){
				var newindex= this.cases_best_opened.length - index;
				return newindex;
			}
		}
	},
	async mounted() {

		await this.get_cases_opened();

		this.cases_opened = this.stock_cases_opened.splice(0, 11);
		this.cases_best_opened = this.stock_cases_best_opened.splice(0, 10);

		this.timer = setInterval(() => {
				this.changeWiew();
		}, 2000);

	},
	created() {
	},
	methods: {
		isGameTypeVisible(item) {

			if(!item.item)
				return false;

			const featureKeys = {
				1: 'upgrade',
				2: 'rolls',
				4: 'battle',
			};
			return this.$canShowFeature(featureKeys[item.gameType]);
		},
		async switchType(type){

			if(this.drop_type == type)
				return;

			this.drop_type = type;

			clearInterval(this.timer);

			//this.cases_opened = [];

			await this.get_cases_opened();

			if(this.drop_type == 0){
				this.cases_opened = this.stock_cases_opened.splice(0, 10);
			}else{
				this.cases_best_opened = this.stock_cases_best_opened.splice(0, 10);
			}
	
			this.timer = setInterval(() => {				
				if(this.drop_type == 0){
					this.changeWiew();
				} else{
					this.changeTopWiew();
				}
			}, 2000);
		},
		/** 开箱历史记录点击 */
		async on_cases_opened_click(row) {
			if (!this.isGameTypeVisible(row)) return;

			let case_router = {};

			switch(row.gameType){
			case 0:
				case_router = this.$router.resolve({
					name: 'case',
					params: { id: row.caseId }
				});
				break;
			case 1:
				case_router = this.$router.resolve({
					name: 'upgradeList'
				});				
				break;
			case 2:
				case_router = this.$router.resolve({
					name: 'rolls'
				});				
				break;
			case 4:
				case_router = this.$router.resolve({
					name: 'battle'
				});
				break;
			}

			if (case_router.route.path === this.$route.path) return;

			this.$router.push({
				...case_router.route,
				query: { ...(this.$route.query || {}), ...(case_router.route.query || {}) },
			});
		},
		async get_cases_opened() {
			if (this.pageHidden) return
			var data=null;
			
			if(this.$props.caseId > 0){
				data = { caseId : this.$props.caseId};
				console.log(this.$props.caseId);
			}

			const cases_opened_response = await apis.indexHistory(data);
			
			this.stock_cases_opened = cases_opened_response.data.data.list;

			this.best_item = this.stock_cases_opened.slice().sort((a,b)=>{ return b.item?.sellPrice - a.item?.sellPrice})[0];
			this.best_drop = cases_opened_response.data.data.best; 

			//const cases_best_opened_response = await apis.indexHistoryBest(data);
			this.stock_cases_best_opened = cases_opened_response.data.data.best;
		},
		async changeWiew() {
			if(this.pause_flag)
				return;

			if( this.cases_opened.length>20) //性能考虑
				this.cases_opened = this.cases_opened.slice(0,10);

			//因为要满足最小随机数量3 所以小于三个元素就重新向服务器请求
			if (this.stock_cases_opened.length < 3){
				//this.cases_opened = [];
				await this.get_cases_opened();
			}
				

			//计算随机数量
			var randnum = 1;
			
			//从预备列表里取出相应的数量
			var insertItems = this.stock_cases_opened.splice(0, randnum);
			//插入到最前,并把显示数量重置为8个
			this.cases_opened = insertItems.concat(this.cases_opened);
		},
		async changeTopWiew() {
			if(this.pause_flag)
				return;

			if( this.cases_best_opened.length>20) //性能考虑
				this.cases_best_opened = this.cases_best_opened.slice(0,10);

			//因为要满足最小随机数量3 所以小于三个元素就重新向服务器请求
			if (this.stock_cases_best_opened.length < 3){
				//this.cases_best_opened = [];
				await this.get_cases_opened();
			}

			//计算随机数量
			var randnum = 1;
			
			//从预备列表里取出相应的数量
			var insertItems = this.stock_cases_best_opened.splice(0, randnum);
			//插入到最前,并把显示数量重置为8个
			this.cases_best_opened = insertItems.concat(this.cases_best_opened);
		}
	},

};
